import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const AddApartment = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const [cities, setCities] = useState([]);
  const [localities, setLocalities] = useState([]);

  const initialFormData = {
    city: "",
    locality: "",
    aptName: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const navigate = useNavigate();

  const handleChange = (e) => {
    e.preventDefault();

    let name = e.target.name;
    let value = e.target.value;

    if (name === "phoneNo" || name === "salary") {
      value = parseInt(value);
    }

    setFormData({ ...formData, [name]: value });
  };

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      console.log("HYT71", res);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.locality) return toast.error("Locality should not be empty");
    console.log("HD51", formData);
    const payload = { ...formData, aptName: formData?.aptName?.trim() };
    try {
      const res = await HomeService.addApartment(payload);
      if (res?.status) {
        toast.success("Apartment added successfully!");
        setFormData(initialFormData);
        navigate("/manage-apartment");
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      // toast.error("Failed to add Apartment.");
      console.error("Error adding Apartment:", error);
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);

  useEffect(() => {
    fetchLocalities(formData.city);
  }, [formData.city]);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Apartment
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-3 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={formData?.city || ""}
                    onChange={(e) => handleChange(e)}
                    required
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3 mt-3">
                  <label>
                    Locality<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={formData.locality}
                    onChange={(e) => {
                      setFormData({ ...formData, locality: e.target.value });
                    }}
                    required
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="aptName">
                    Apartment Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="aptName"
                    value={formData?.aptName || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Apartment Name"
                    required
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                }}
              >
                Add
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AddApartment;
